import { useState, useEffect } from "react";

export const useEventCallbackLoader = (options = {}) => {
  const { user, state, dispatch, actions } = options;

  // track callback loader state for event callbacks
  const [callbackActioned, setCallbackActioned] = useState(null);

  // effect to monitor callbackState for any activity post callbackLoader
  useEffect(() => {
    if (user.connected && state.callbackState && !state.callbackLoader) {
      switch (state.callbackState.type) {
        case "actionDrawer":
          // dispatch({
          //   type: eventActions.SET_ACTION_DRAWER,
          //   drawer: {
          //     open: true,
          //     ...state.callbackState.payload,
          //   },
          // });
          break;
        default:
          break;
      }
      console.log(
        "[CALLBACK LOADER] Actioned callback",
        state.callbackState.type,
      );
      dispatch({
        type: actions.SET_CALLBACK_LOADER,
        callbackLoader: false,
        callbackState: null,
      });
      setCallbackActioned(state.callbackState.type);
    }
  }, [
    callbackActioned,
    state.callbackLoader,
    state.callbackState,
    user,
    dispatch,
    actions,
  ]);

  return [callbackActioned, setCallbackActioned];
};
